import { createContext } from "react";

export const SingletonContext = createContext({
  user: null,
  role: null,
  mail: null,
  board: null,
  examType: null,
  medium: null,
  sessionTime: null,
  section: null,
  subscription: null,
  updateMail: () => {},
  updateUserData: () => {},
  updateRole: () => {},
  updateBoard: () => {},
  updateExam: () => {},
  updateMedium: () => {},
  updateSession: () => {},
  updateSection: () => {},
  updateSubscription: () => {},
  updateSubscribedCourses: () => {},
  getUserDetails: () => {},
});

export const NotifyContext = createContext({
  notify: null,
  toggleNotify: () => {},
});
